import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgpFormField } from 'ng-primitives/form-field';

@Component({
  selector: 'sui-form-field',
  standalone: true,
  imports: [],
  templateUrl: './sui-form-field.component.html',
  styleUrl: './sui-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [NgpFormField],
})
export class SuiFormFieldComponent {}
